// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Col,
//   DatePicker,
//   Row,
//   Typography,
//   Spin,
//   Divider,
//   Tag,
//   Empty,
// } from "antd";
// import moment from "moment";
// import { getOrderApi } from "../../services/orderApi";

// const { Title, Text } = Typography;
// const { RangePicker } = DatePicker;

// const ViewOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [dateRange, setDateRange] = useState([null, null]);

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async (start, end) => {
//     try {
//       setLoading(true);
//       const res = await getOrderApi({start, end});
//       setOrders(res || []);
//     } catch (err) {
//       console.error("Failed to fetch orders", err);
//     } finally {
//       setLoading(false);
//     }
//   };

// //   const handleDateChange = (dates) => {
// //     setDateRange(dates);
// //     if (dates && dates[0] && dates[1]) {
// //       const start = moment(dates[0]).startOf("day").toISOString();
// //       const end = moment(dates[1]).endOf("day").toISOString();
// //       fetchOrders(start, end);
// //     } else {
// //       fetchOrders(); // all orders if no date selected
// //     }
// //   };


// const handleDateChange = (dates) => {
//     setDateRange(dates);
//     if (dates && dates[0] && dates[1]) {
//       const start = moment(dates[0]).startOf("day").toISOString();
//       const end = moment(dates[1]).endOf("day").toISOString();
//       fetchOrders(start, end);
//     } else {
//       fetchOrders(); // all orders if no date selected
//     }
//   };

//   // Group orders by date (YYYY-MM-DD)
//   const groupedOrders = orders.reduce((acc, order) => {
//     const dateKey = moment(order.createdAt).format("YYYY-MM-DD");
//     if (!acc[dateKey]) acc[dateKey] = [];
//     acc[dateKey].push(order);
//     return acc;
//   }, {});

// //   return (
// //     <div style={{ padding: 24 }}>
// //       <Title level={3}>View Orders</Title>

// //       <RangePicker
// //         style={{ marginBottom: 24 }}
// //         onChange={handleDateChange}
// //         value={dateRange}
// //         allowClear
// //       />

// //       {loading ? (
// //         <Spin />
// //       ) : orders.length === 0 ? (
// //         <Empty description="No orders found" />
// //       ) : (
// //         <Row gutter={[16, 16]}>
// //           {orders.map((order) => (
// //             <Col xs={24} sm={12} md={8} key={order._id}>
// //               <Card title={order.clientName} bordered hoverable>
// //                 <Text>
// //                   <strong>Staff:</strong> {order.staff?.userName}
// //                 </Text>
// //                 <br />
// //                 <Text>
// //                   <strong>Company:</strong> {order.company?.name || "N/A"}
// //                 </Text>
// //                 <Divider style={{ margin: "8px 0" }} />
// //                 <Text strong>Services:</Text>
// //                 <div style={{ margin: "8px 0" }}>
// //                   {order.serviceList?.map((s, idx) => (
// //                     <Tag key={idx} color="blue">
// //                       {s.name} - ₹{s.price}
// //                     </Tag>
// //                   ))}
// //                 </div>
// //                 <Divider style={{ margin: "8px 0" }} />
// //                 <Text>
// //                   <strong>Total:</strong>{" "}
// //                   <span style={{ color: "green" }}>₹{order.totalAmount}</span>
// //                 </Text>
// //               </Card>
// //             </Col>
// //           ))}
// //         </Row>
// //       )}
// //     </div>
// //   );

//   return (
//     <div style={{ padding: 24 }}>
//       <Title level={3}>View Orders</Title>

//       <RangePicker
//         style={{ marginBottom: 24 }}
//         onChange={handleDateChange}
//         value={dateRange}
//         allowClear
//       />

//       {loading ? (
//         <Spin />
//       ) : Object.keys(groupedOrders).length === 0 ? (
//         <Empty description="No orders found" />
//       ) : (
//         Object.entries(groupedOrders).map(([date, ordersOnDate]) => (
//           <div key={date}>
//             <Title level={4} style={{ marginTop: 32 }}>
//               {moment(date).format("DD MMMM YYYY")}
//             </Title>

//             <Row gutter={[16, 16]}>
//               {ordersOnDate.map((order) => (
//                 <Col xs={24} sm={12} md={8} key={order._id}>
//                   <Card title={order.clientName} bordered hoverable>
//                     <Text>
//                       <strong>Staff:</strong> {order.staff?.userName}
//                     </Text>
//                     <br />
//                     <Text>
//                       <strong>Company:</strong>{" "}
//                       {order.company?.name || "N/A"}
//                     </Text>
//                     <Divider style={{ margin: "8px 0" }} />
//                     <Text strong>Services:</Text>
//                     <div style={{ margin: "8px 0" }}>
//                       {order.serviceList?.map((s, idx) => (
//                         <Tag key={idx} color="blue">
//                           {s.name} - ₹{s.price}
//                         </Tag>
//                       ))}
//                     </div>
//                     <Divider style={{ margin: "8px 0" }} />
//                     <Text>
//                       <strong>Total:</strong>{" "}
//                       <span style={{ color: "green" }}>
//                         ₹{order.totalAmount}
//                       </span>
//                     </Text>
//                   </Card>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         ))
//       )}
//     </div>
//   );


// };

// export default ViewOrders;


import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  DatePicker,
  Row,
  Typography,
  Spin,
  Divider,
  Tag,
  Empty,
  Badge,
  Space,
  Avatar,
  Button,
  Alert,
  Tooltip,
} from "antd";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  DollarOutlined,
  ShopOutlined,
  TeamOutlined,
  FireOutlined,
  CheckCircleOutlined,
  ScheduleOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { getOrderApi } from "../../services/orderApi";

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

// Mock API function - replace with your actual API
// const getOrderApi = async ({ start, end } = {}) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve([
//         {
//           "staff": {
//             "userId": "6886712302f337fd383a2724",
//             "userName": "test pay2"
//           },
//           "company": {
//             "id": "6871e6d36f3c82dbe7b21f22",
//             "name": "Test bappun franchise"
//           },
//           "tenant": {
//             "id": "6871e6b66f3c82dbe7b21f1b",
//             "name": "Test tenant"
//           },
//           "_id": "6886c6aaffbb7293dd0773fe",
//           "clientName": "test",
//           "email": "jatinaroraaaa3@gmail.com",
//           "number": "2213456112",
//           "totalAmount": 100,
//           "type": "scheduled",
//           "createdBy": "6871e27acbf3bc5b37c1e60c",
//           "serviceList": [
//             {
//               "id": "6886b47150e1c33204fcd13b",
//               "name": "haircut",
//               "price": 100,
//               "_id": "6886c6aaffbb7293dd0773ff"
//             }
//           ],
//           "appointmentDate": new Date().toISOString(), // Today's appointment
//           "appointmentTime": "2025-07-28T14:15:00.000Z",
//           "time": "2025-07-28T00:39:06.455Z",
//           "createdAt": "2025-07-28T00:39:07.236Z",
//           "updatedAt": "2025-07-28T00:39:07.236Z",
//           "__v": 0
//         },
//         {
//           "staff": {
//             "userId": "6871e826aad0f2fd0f6895a5",
//             "userName": "Jatin Arora"
//           },
//           "company": {
//             "id": "6871e6d36f3c82dbe7b21f22",
//             "name": "Test bappun franchise"
//           },
//           "tenant": {
//             "id": "6871e6b66f3c82dbe7b21f1b",
//             "name": "Test tenant"
//           },
//           "appointmentDate": null,
//           "appointmentTime": null,
//           "_id": "6871fa6e45941718f0b691ec",
//           "clientName": "test client",
//           "email": "",
//           "number": "1212121212",
//           "totalAmount": 1000,
//           "type": "onsite",
//           "createdBy": "6871e826aad0f2fd0f6895a5",
//           "serviceList": [
//             {
//               "id": "6871d45e3ece50444cd7b79d",
//               "name": "chemical work peal",
//               "price": 1000,
//               "_id": "6871fa6e45941718f0b691ed"
//             }
//           ],
//           "time": "2025-07-12T06:02:22.857Z",
//           "createdAt": "2025-07-12T06:02:22.862Z",
//           "updatedAt": "2025-07-12T06:02:22.862Z",
//           "__v": 0
//         },
//         {
//           "staff": {
//             "userId": "6871e826aad0f2fd0f6895a5",
//             "userName": "Jatin Arora"
//           },
//           "company": {
//             "id": "6871e6d36f3c82dbe7b21f22",
//             "name": "Test bappun franchise"
//           },
//           "tenant": {
//             "id": "6871e6b66f3c82dbe7b21f1b",
//             "name": "Test tenant"
//           },
//           "appointmentDate": null,
//           "appointmentTime": null,
//           "_id": "6871fedc45941718f0b69201",
//           "clientName": "test 2 for diff",
//           "email": "",
//           "number": "1212354345",
//           "totalAmount": 1200,
//           "type": "onsite",
//           "createdBy": "6871e826aad0f2fd0f6895a5",
//           "serviceList": [
//             {
//               "id": "6871d3313ece50444cd7b797",
//               "name": "haircut",
//               "price": 200,
//               "_id": "6871fedc45941718f0b69202"
//             },
//             {
//               "id": "6871d45e3ece50444cd7b79d",
//               "name": "chemical work peal",
//               "price": 1000,
//               "_id": "6871fedc45941718f0b69203"
//             }
//           ],
//           "time": "2025-07-12T06:21:16.182Z",
//           "createdAt": "2025-07-11T06:21:16.183Z",
//           "updatedAt": "2025-07-11T06:21:16.183Z",
//           "__v": 0
//         }
//       ]);
//     }, 1000);
//   });
// };

const ViewOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const {companyId} = useParams()
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async (start, end) => {
    try {
      setLoading(true);
      const res = await getOrderApi({ start, end,companyId:companyId });
      setOrders(res || []);
    } catch (err) {
      console.error("Failed to fetch orders", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
    if (dates && dates[0] && dates[1]) {
      const start = new Date(dates[0]).toISOString();
      const end = new Date(dates[1]).toISOString();
      fetchOrders(start, end);
    } else {
      fetchOrders();
    }
  };

  // Check if appointment is today
  const isToday = (dateString) => {
    if (!dateString) return false;
    const today = new Date().toDateString();
    const appointmentDate = new Date(dateString).toDateString();
    return today === appointmentDate;
  };

  // Separate today's appointments and other orders
  const todaysAppointments = orders.filter(order => 
    order.type === 'scheduled' && 
    order.appointmentDate && 
    isToday(order.appointmentDate)
  );

  const otherOrders = orders.filter(order => 
    !(order.type === 'scheduled' && order.appointmentDate && isToday(order.appointmentDate))
  );

  // Group other orders by date
  const groupedOrders = otherOrders.reduce((acc, order) => {
    const dateKey = new Date(order.createdAt).toDateString();
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(order);
    return acc;
  }, {});

  const formatTime = (timeString) => {
    if (!timeString) return 'Not specified';
    return new Date(timeString).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const OrderCard = ({ order, isAppointment = false }) => (
    <Card
      hoverable
      style={{
        borderRadius: '16px',
        overflow: 'hidden',
        border: isAppointment ? '2px solid #ff7875' : '1px solid #f0f0f0',
        boxShadow: isAppointment 
          ? '0 8px 32px rgba(255,120,117,0.3)' 
          : '0 4px 12px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
      }}
      bodyStyle={{ padding: '20px' }}
    >
      {/* Header with client name and type */}
      <div style={{ marginBottom: '16px' }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Title level={4} style={{ margin: 0, color: '#1a1a1a' }}>
              {order.clientName}
            </Title>
          </Col>
          <Col>
            <Tag 
              color={order.type === 'scheduled' ? 'orange' : 'blue'}
              style={{ borderRadius: '8px', fontWeight: 'bold' }}
            >
              {order.type === 'scheduled' ? (
                <><ScheduleOutlined style={{ marginRight: '4px' }} />Scheduled</>
              ) : (
                <><CheckCircleOutlined style={{ marginRight: '4px' }} />Onsite</>
              )}
            </Tag>
          </Col>
        </Row>
        
        {isAppointment && (
          <div style={{ 
            marginTop: '8px', 
            background: '#fff2f0', 
            padding: '8px 12px', 
            borderRadius: '8px',
            border: '1px solid #ffccc7'
          }}>
            <Space>
              <FireOutlined style={{ color: '#ff4d4f' }} />
              <Text strong style={{ color: '#ff4d4f', fontSize: '12px' }}>
                TODAY'S APPOINTMENT
              </Text>
            </Space>
          </div>
        )}
      </div>

      {/* Contact Information */}
      <div style={{ marginBottom: '16px' }}>
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
          <Space>
            <PhoneOutlined style={{ color: '#52c41a' }} />
            <Text>{order.number}</Text>
          </Space>
          {order.email && (
            <Space>
              <MailOutlined style={{ color: '#1890ff' }} />
              <Text type="secondary">{order.email}</Text>
            </Space>
          )}
        </Space>
      </div>

      {/* Appointment Details for scheduled orders */}
      {order.type === 'scheduled' && order.appointmentDate && (
        <div style={{ 
          marginBottom: '16px',
          background: '#f6ffed',
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #b7eb8f'
        }}>
          <Space direction="vertical" size={4}>
            <Space>
              <CalendarOutlined style={{ color: '#52c41a' }} />
              <Text strong>
                {isToday(order.appointmentDate) ? 'Today' : formatDate(order.appointmentDate)}
              </Text>
            </Space>
            <Space>
              <ClockCircleOutlined style={{ color: '#1890ff' }} />
              <Text>{formatTime(order.appointmentTime)}</Text>
            </Space>
          </Space>
        </div>
      )}

      {/* Staff and Company Info */}
      <div style={{ marginBottom: '16px' }}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Space>
              <TeamOutlined style={{ color: '#722ed1' }} />
              <Text><strong>Staff:</strong> {order.staff?.userName}</Text>
            </Space>
          </Col>
          <Col span={24}>
            <Space>
              <ShopOutlined style={{ color: '#fa8c16' }} />
              <Text><strong>Company:</strong> {order.company?.name || "N/A"}</Text>
            </Space>
          </Col>
        </Row>
      </div>
      {order.paymentMode && (
        <div style={{ marginBottom: '16px' }}>
          <Space>
            {order.paymentMode === 'cash' ? (
              <>
                <DollarOutlined style={{ color: '#52c41a' }} />
                <Text><strong>Payment:</strong> Cash</Text>
              </>
            ) : (
              <>
                <CreditCardOutlined style={{ color: '#1890ff' }} />
                <Text><strong>Payment:</strong> Online</Text>
              </>
            )}
          </Space>
        </div>
      )}
      <Divider style={{ margin: '16px 0' }} />

      {/* Services */}
      <div style={{ marginBottom: '16px' }}>
        <Text strong style={{ marginBottom: '8px', display: 'block' }}>Services:</Text>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {order.serviceList?.map((service, idx) => (
            <Tag 
              key={idx} 
              color="processing"
              style={{ 
                borderRadius: '12px', 
                padding: '4px 8px',
                fontSize: '12px'
              }}
            >
              {service.name} - ₹{service.price}
            </Tag>
          ))}
        </div>
      </div>

      {/* Total Amount */}
      <div style={{
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)',
        padding: '12px 16px',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Space>
          <DollarOutlined style={{ color: '#52c41a', fontSize: '18px' }} />
          <Text strong style={{ fontSize: '18px', color: '#52c41a' }}>
            Total: ₹{order.totalAmount}
          </Text>
        </Space>
      </div>
    </Card>
  );

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '24px'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '32px',
          marginBottom: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Row align="middle" justify="space-between">
            <Col>
              <Title level={2} style={{ 
                margin: 0,
                marginBottom: '8px',
                background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '32px'
              }}>
                Orders & Appointments
              </Title>
              <Text type="secondary" style={{ fontSize: '16px' }}>
                Manage your daily orders and scheduled appointments
              </Text>
            </Col>
            <Col>
              <Badge count={todaysAppointments.length} style={{ backgroundColor: '#ff4d4f' }}>
                <Avatar 
                  size={48} 
                  icon={<CalendarOutlined />} 
                  style={{ backgroundColor: '#1890ff' }}
                />
              </Badge>
            </Col>
          </Row>
        </div>

        {/* Date Range Filter */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          marginBottom: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Row align="middle" gutter={[16, 16]}>
            <Col xs={24} md={16}>
              <RangePicker
                style={{ width: '100%', borderRadius: '12px' }}
                size="large"
                onChange={handleDateChange}
                value={dateRange}
                allowClear
                placeholder={['Start Date', 'End Date']}
              />
            </Col>
            <Col xs={24} md={8} style={{ textAlign: 'right' }}>
              <div style={{
                background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'inline-block'
              }}>
                Total Orders: {orders.length}
              </div>
            </Col>
          </Row>
        </div>

        {loading ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '80px 0',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
          }}>
            <Spin size="large" />
            <div style={{ marginTop: '16px' }}>
              <Text type="secondary">Loading orders...</Text>
            </div>
          </div>
        ) : (
          <>
            {/* Today's Appointments Section */}
            {todaysAppointments.length > 0 && (
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '24px',
                marginBottom: '24px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                border: '2px solid #ff7875'
              }}>
                <div style={{ marginBottom: '24px' }}>
                  <Space align="center">
                    {/* <FireOutlined style={{ color: '#ff4d4f', fontSize: '24px' }} /> */}
                    <Title level={3} style={{ margin: 0, color: '#ff4d4f' }}>
                      Today's Appointments
                    </Title>
                    <Badge count={todaysAppointments.length} style={{ backgroundColor: '#ff4d4f' }} />
                  </Space>
                  {/* <Text type="secondary" style={{ marginLeft: '32px' }}>
                    Urgent appointments scheduled for today
                  </Text> */}
                </div>

                <Row gutter={[24, 24]}>
                  {todaysAppointments.map((order) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={order._id}>
                      <OrderCard order={order} isAppointment={true} />
                    </Col>
                  ))}
                </Row>
              </div>
            )}

            {/* Other Orders Section */}
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '24px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}>
              {Object.keys(groupedOrders).length === 0 && todaysAppointments.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <Empty 
                    description="No orders found"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </div>
              ) : (
                Object.entries(groupedOrders).map(([date, ordersOnDate]) => (
                  <div key={date} style={{ marginBottom: '32px' }}>
                    <Title level={4} style={{ 
                      color: '#1890ff', 
                      marginBottom: '16px',
                      paddingBottom: '8px',
                      borderBottom: '2px solid #f0f0f0'
                    }}>
                      {formatDate(date)}
                    </Title>

                    <Row gutter={[24, 24]}>
                      {ordersOnDate.map((order) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={order._id}>
                          <OrderCard order={order} />
                        </Col>
                      ))}
                    </Row>
                  </div>
                ))
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ViewOrders;